import { gql } from '@apollo/client';

const ORGANIZATION_ASSOCIATION_LICENSE_USAGE_FRAGMENT = gql`
  fragment BaseOrganizationAssociationLicenseUsage on UserOrganization {
    organization {
      id
      name
      licenseUsage {
        product {
          id
          code
          name
          iconUrl
          type
        }
        productCurriculum {
          id
          code
          name
          iconUrl
        }
        availableCount
        assignedCount
        siteLicensed
      }
    }
  }
`;

export default ORGANIZATION_ASSOCIATION_LICENSE_USAGE_FRAGMENT;
